import axios from "axios";
import Authentication from "../Store/Authentication/AuthenticationStore";
import history from "./history";
import { HttpError } from "./types";


export const configAxios = () => {
    axios.interceptors.request.use(async conf => {
        conf.withCredentials = true;
        return conf;
    });

    axios.interceptors.response.use(undefined, error => {
        if (error.config) {
            var url = error.config.url as String;
            if (url.includes("/login"))
                return Promise.reject(error);
        }

        let httpError: HttpError;

        if (error.code === "ECONNABORTED") {
            httpError = new HttpError(
                Date.now(),
                408,
                "Request Timeout",
                "Request timeout."
            );
            return Promise.reject(httpError);
        }

        if (!error.response) {
            httpError = new HttpError(
                Date.now(),
                -1,
                "Network Error",
                error.message
            );
            return Promise.reject(httpError);
        }

        const { status, data } = error.response;

        if (status === 401) {
            httpError = new HttpError(Date.now(), 401, "", "");
            if (Authentication.isAdminAuthenticated() || Authentication.isAdjudicatorAuthenticated()) {
                Authentication.logout();
                httpError.message = "Session expired";
            } else {
                history.push("/login");
                httpError.message = "Authentication needed";
            }
            return Promise.reject(httpError);
        }

        if (status === 504) {
            httpError = new HttpError(
                Date.now(),
                504,
                "Gateway Timeout",
                "Timeout, the server took too long to respond."
            );
            return Promise.reject(httpError);
        }

        httpError = new HttpError(
            data?.timestamp ?? Date.now(),
            status,
            data?.error ?? "Error",
            data?.message ?? "Unexpected error"
        );

        return Promise.reject(httpError);
    });
};

const getEnvVariableValue = (variable: string | undefined): string => {
    if (variable)
        return variable;
    return "";
}

const DEFAULT_IP_ADDRESS = "http://localhost"

export const API_BASE_PREFIX = process.env.NODE_ENV === 'production' ? getEnvVariableValue(process.env.REACT_APP_API_BASE_PREFIX) : "";
export const API_BASE_URL = process.env.NODE_ENV === 'production' ? getEnvVariableValue(process.env.REACT_APP_API_BASE_URL) : DEFAULT_IP_ADDRESS + ":40002";

export const getFullApiUrl = (): string => {
    return API_BASE_URL + API_BASE_PREFIX;
};

export default configAxios;
